import { Injectable } from '@angular/core';
import { CardDataWithPropertyPooling } from '../../../shared/card-data-with-property-pooling';
import { map } from 'rxjs/operators';

@Injectable()
export class MasterKushStrainVariantViewModel extends CardDataWithPropertyPooling {
  public propertiesSortedForDisplay$ = this.propertiesBasedOnPools$.pipe(
    map(properties => {
      const firstProperty = properties?.firstOrNull();
      if (firstProperty?.title === 'TERPS' && properties?.length > 1) {
        return properties.rotateInPlaceCounterClockwise();
      } else {
        return properties;
      }
    })
  );
}
